import { ApolloError } from '@apollo/client';

import {
  STRIPE_ERROR_CODE_CARD_DECLINED,
  STRIPE_ERROR_TYPE_CARD_ERROR,
} from 'global/constants';

type NetworkErrorResult = {
  result?: { errors?: Array<{ message?: unknown }> };
};

const getServerErrorObject = (error?: ApolloError) => {
  const networkMessage = (error?.networkError as unknown as NetworkErrorResult)
    ?.result?.errors?.[0]?.message;
  const graphQLMessage = error?.graphQLErrors?.[0]?.message;
  const fullMessage =
    typeof networkMessage === 'string'
      ? networkMessage
      : typeof graphQLMessage === 'string'
        ? graphQLMessage
        : undefined;

  let type: string | undefined;
  let code: string | undefined;
  let message: string | undefined;
  if (fullMessage?.includes('|')) {
    [type, code, message] = fullMessage.split('|');
  } else {
    message = fullMessage;
  }

  return { type, code, message };
};

export const getServerErrorMessage = (
  error?: ApolloError
): string | null | undefined => getServerErrorObject(error).message;

export const getServerErrorReason = (
  error?: ApolloError
): string | null | undefined =>
  (error?.networkError as any)?.result?.reason?.[0]?.message;

export const isCardDeclinedError = (error?: ApolloError) => {
  const { type, code } = getServerErrorObject(error);
  return (
    type === STRIPE_ERROR_TYPE_CARD_ERROR ||
    code === STRIPE_ERROR_CODE_CARD_DECLINED
  );
};
